// Vendor Components
import React from 'react'
import styled from 'styled-components'
import { withPrefix } from 'gatsby-link'

// Components
import Main from '../components/container/main/main'
import Carousel from '../components/carousel/carousel'
import CountUp from '../components/section/countup/countup'
import Interest from '../components/section/interest/interest'
import Methodology from '../components/section/methodology/methodology'
import Business from '../components/section/business/business'
import Paragraph from '../components/section/paragraph/paragraph'
import SimpleButton from '../components/button/simple'
import Stories from '../components/section/stories/stories'

const BannerContainer = styled.div`
  @media (min-width: 1200px) {
    height: 460px;
  }
`
const BannerWrapper = styled.div`
  background-image: ${props => props.background};
  padding-top: 3rem;
`

const WrapperBannerImage = styled.div`
  overflow: hidden;
`
const BannerImage = styled.img`
  position: relative;
  bottom: -25px;
  right: -45px;
  @media (max-width: 768px) {
    bottom: 0;
    right: 0;
  }
`
const StyledTitle = styled.h1`
  color: #3c4252;
  font-weight: 600;
`
const StyledSubTitle = styled.h2`
  color: #3c4252;
  font-weight: 300;
  font-size: 1.75rem;
`

const Container = styled.div`
  padding-top: 3rem;
  padding-bottom: 3rem;
`

const Template = props => {
  const {
    title,
    subtitle,
    paragraph,
    business,
    introMethodology,
    methodology,
    prevTitle,
    background,
    banner,
    stories,
    counters
  } = props.data.templatesJson

  const items = props.data.allTemplatesJson.edges
  return (
    <Main
      items={items}
      children={({ menuIsOpen, contactIsOpen, toggleContact }) => (
        <main>
          <BannerWrapper className="container-fluid" background={background}>
            <div className="container">
              <div className="row">
                <div className="col-12 col-xl-4 align-self-center">
                  <StyledTitle className="text-center text-xl-left">
                    {title}
                  </StyledTitle>
                  <StyledSubTitle className="mt-1 mb-3 text-center text-xl-left">
                    {subtitle}
                  </StyledSubTitle>
                  <SimpleButton
                    className="d-none d-lg-block"
                    title="QUIERO SABER MÁS"
                    onClick={() => toggleContact(!contactIsOpen)}
                  />
                </div>
                <WrapperBannerImage className="col-12 col-xl-8 text-center text-md-right align-self-center">
                  <BannerImage
                    className={'img-fluid'}
                    src={withPrefix(`/${banner.image}`)}
                  />
                </WrapperBannerImage>
              </div>
              <div className="col-12 text-center d-lg-none">
                <SimpleButton
                  className="my-4"
                  title="QUIERO SABER MÁS"
                  onClick={() => toggleContact(!contactIsOpen)}
                />
              </div>
            </div>
          </BannerWrapper>
          <Container className="container">
            <div className="row">
              <div className="col-12">
                <Paragraph paragraph={paragraph[0]} />
                <Business business={business} prevTitle={prevTitle} />
                <Paragraph paragraph={paragraph[1]} />
              </div>
            </div>
          </Container>
          <Methodology
            className="container-fluid"
            methodology={methodology}
            introMethodology={introMethodology}
          />
          <Stories className="container" stories={stories} />
          <Interest
            contactIsOpen={contactIsOpen}
            toggleContact={toggleContact}
            className="container-fluid"
            title={title.toLowerCase()}
          />
          <CountUp className="container-fluid" counters={counters} />
          <Carousel className="container" />
        </main>
      )}
    />
  )
}

export const query = graphql`
  query PathsQuery($slug: String!) {
    templatesJson(slug: { eq: $slug }) {
      title
      link
      subtitle
      paragraph
      prevTitle
      business {
        title
        text
      }
      introMethodology
      methodology {
        title
        icon
        text
      }
      background
      banner {
        position {
          bottom
          right
        }
        image
      }
      stories {
        title
        items {
          title
          subtitle
          introduction
          detailtitle
          detail
          image
          background
        }
      }
      counters {
        start
        end
        title
      }
    }
    allTemplatesJson {
      edges {
        node {
          title
          link
        }
      }
    }
  }
`

export default Template



// WEBPACK FOOTER //
// ./src/templates/template.js